// extracted by mini-css-extract-plugin
export var apiV2 = "api-v2_mFgZoQTL2Hn96R1SFEfg";
export var apiV2Tabs = "api-v2__tabs_jOwIX6C9EcDLGmSML0L0";
export var ellipsis = "ellipsis_hJC5T4_DE6fpy6Tc4sNN";
export var microappFrame = "microapp-frame_cPDYBcWTh5iohuspkQIA";
export var textAlign = "text-align_eVwPpNbNh0tVmB0FnaCy";
export var textAlignCenter = "text-align_center_i8iT_sZNfjsXnHzeDAUN";
export var textAlignRight = "text-align_right_naAO2mmosUnwcxyydVmZ";